<template>
    <div>
        <div class="form-group">
            <label>Date from</label>
            <date-picker name="from"  v-model="fromDate" :max="toDate" :options="{ firstDay: 1 }"></date-picker>
            <a href="#" @click.prevent="fromDate = null" v-if="fromDate">Clear</a>
        </div>
        <div class="form-group">
            <label>to</label>
            <date-picker name="to" v-model="toDate" :min="fromDate" :options="{ firstDay: 1 }"></date-picker>
            <a href="#" @click.prevent="toDate = null" v-if="toDate">Clear</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            from: {
                type: String,
                default: ''
            },
            to: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                fromDate: this.from,
                toDate: this.to,
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/DateRange.vue